export enum SessionStorageType {
    APP = 'LZ-llc-app',
    CART = 'LZ-llc-cart'
}
